import {
    DTOCardFormField,
} from 'app/types/form.types'
import {
    ContactType,
} from 'app/enums/label.enums'

import {
    BillingCompany,
} from '../../BillingCompanyForm.types'

const communicationFields: DTOCardFormField<keyof BillingCompany> = {
    id: 'communication',
    title: 'Communication',
    className: 'communication',
    'data-testid': 'card-communication',
    fields: [{
        id: 'communication-column1',
        fields: [
            {
                name: 'emailContacts',
                componentName: 'LongText',
                disabled: true,
                required: true,
                rows: 2,
                labelKey: 'BillingCompanyView.emailContacts',
            },
            {
                name: 'emailRecipients',
                componentName: 'MultipleContactObjectSelector',
                required: true,
                labelKey: 'BillingCompanyView.emailRecipients',
                includeFilters: {
                    type: [ContactType.BILLING_CONTACT],
                },
            },
            {
                name: 'emailCc',
                componentName: 'MultipleContactObjectSelector',
                labelKey: 'BillingCompanyView.emailCc',
                filters: {
                    onlySkyCellContacts: true,
                },
            },
            {
                name: 'instructionsForBilling',
                componentName: 'LongText',
                labelKey: 'OrderBillingInformationView.instructionsForBilling',
            },
            {
                name: 'sapBusinessPartnerNumber',
                componentName: 'LongText',
                disabled: true,
                labelKey: 'BillingCompanyView.sapBusinessPartnerNumber',
            },
        ],
    }],
}

export default communicationFields
